// 用户评论系统
// 模拟用户评论数据
const mockComments = {
    "tiger-leaping-gorge": [
        {
            id: 1,
            username: "山野行者",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=hiker1",
            rating: 5,
            date: "2024-01-15",
            content: "虎跳峡真的太震撼了！金沙江的咆哮声让人心潮澎湃，28道拐虽然累但是值得。建议大家一定要带好装备，路况有些地方比较险峻。",
            likes: 23,
            helpful: true
        },
        {
            id: 2,
            username: "云南小驴",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=yunnan",
            rating: 4,
            date: "2024-01-10",
            content: "第三次走虎跳峡了，每次都有不同的感受。这次遇到了很好的天气，哈巴雪山看得特别清楚。住在中途客栈的体验也很棒，老板人很好。",
            likes: 18,
            helpful: true
        },
        {
            id: 3,
            username: "摄影师小王",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=photographer",
            rating: 5,
            date: "2024-01-08",
            content: "作为摄影师，这里简直是天堂！日出日落的光线打在雪山上美得不像话。建议带长焦镜头，可以拍到很多野生动物。",
            likes: 31,
            helpful: true
        },
        {
            id: 4,
            username: "户外新手",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=newbie",
            rating: 3,
            date: "2024-01-05",
            content: "第一次徒步，选择虎跳峡可能有点挑战性。不过沿途的风景确实很美，就是体力消耗比想象中大。建议新手可以考虑请向导。",
            likes: 12,
            helpful: false
        }
    ],
    "daocheng-yading": [
        {
            id: 5,
            username: "高原行者",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=plateau",
            rating: 5,
            date: "2024-01-20",
            content: "稻城亚丁不愧是最后的香格里拉！三神山太壮观了，牛奶海的颜色真的像牛奶一样。高反有点严重，建议提前做好准备。",
            likes: 45,
            helpful: true
        },
        {
            id: 6,
            username: "藏区达人",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=tibet",
            rating: 5,
            date: "2024-01-18",
            content: "去了三次稻城，每次都被震撼到。建议10月份去，秋色特别美。住宿条件比以前好了很多，但还是要做好心理准备。",
            likes: 28,
            helpful: true
        },
        {
            id: 7,
            username: "自然摄影",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=nature",
            rating: 4,
            date: "2024-01-15",
            content: "五色海真的有五种颜色！不同角度看颜色都不一样。就是海拔太高了，走几步就要休息。相机电池消耗很快，多带几块。",
            likes: 22,
            helpful: true
        }
    ],
    "huihang-ancient-trail": [
        {
            id: 8,
            username: "古道寻踪",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=ancient",
            rating: 4,
            date: "2024-01-12",
            content: "徽杭古道很有历史韵味，石板路保存得很好。沿途的徽派建筑很有特色，适合慢慢走慢慢看。春天去的话还能看到很多野花。",
            likes: 19,
            helpful: true
        },
        {
            id: 9,
            username: "江南行者",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=jiangnan",
            rating: 5,
            date: "2024-01-10",
            content: "非常适合周末徒步的路线！难度不大，风景很美。永来村的农家乐很不错，老板娘做的菜特别香。推荐大家去尝试！",
            likes: 26,
            helpful: true
        }
    ],
    "tea-horse-ancient-road": [
        {
            id: 10,
            username: "茶马古道客",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=teahorse",
            rating: 5,
            date: "2024-01-25",
            content: "走在茶马古道上，仿佛能听到马帮的铃声。这条路承载了太多历史，每一块石头都有故事。建议请当地向导，能听到很多有趣的传说。",
            likes: 33,
            helpful: true
        },
        {
            id: 11,
            username: "文化探索者",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=culture",
            rating: 4,
            date: "2024-01-22",
            content: "不仅仅是徒步，更是一次文化之旅。沿途的纳西族村落保持着原始的生活方式，很值得体验。就是路程比较长，要做好准备。",
            likes: 21,
            helpful: true
        }
    ],
    "wusun-ancient-road": [
        {
            id: 12,
            username: "新疆探险家",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=xinjiang",
            rating: 5,
            date: "2024-01-30",
            content: "乌孙古道是我走过最美的高山徒步路线！雪山、草原、湖泊应有尽有。就是难度比较大，一定要有经验的队友同行。",
            likes: 38,
            helpful: true
        },
        {
            id: 13,
            username: "高山向导",
            avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=guide",
            rating: 4,
            date: "2024-01-28",
            content: "作为向导，我带过很多队伍走乌孙古道。这条路线对体能和装备要求都很高，但风景绝对值得。建议7-9月份去，天气相对稳定。",
            likes: 29,
            helpful: true
        }
    ]
};

// 评论系统类
class CommentSystem {
    constructor() {
        this.comments = mockComments;
    }

    // 获取指定路线的评论
    getComments(routeId) {
        return this.comments[routeId] || [];
    }

    // 渲染评论列表
    renderComments(routeId, containerId = null) {
        // 如果没有提供containerId，则自动生成
        const actualContainerId = containerId || `route-comments-${routeId}`;
        const container = document.getElementById(actualContainerId);
        
        if (!container) {
            console.warn(`评论容器 ${actualContainerId} 不存在`);
            return;
        }

        const comments = this.getComments(routeId);
        if (comments.length === 0) {
            container.innerHTML = '<p class="text-gray-500 text-center py-8">暂无评论</p>';
            return;
        }

        const commentsHtml = comments.map(comment => this.renderSingleComment(comment)).join('');
        
        container.innerHTML = `
            <div class="space-y-6">
                <div class="flex items-center justify-between">
                    <div class="flex items-center space-x-2">
                        <span class="text-sm text-gray-500">平均评分:</span>
                        <div class="flex items-center">
                            ${this.renderStars(this.getAverageRating(comments))}
                            <span class="ml-1 text-sm font-medium text-gray-700">${this.getAverageRating(comments).toFixed(1)}</span>
                        </div>
                        <span class="text-sm text-gray-500">(${comments.length}条评价)</span>
                    </div>
                </div>
                <div class="space-y-4">
                    ${commentsHtml}
                </div>
                <div class="border-t pt-6">
                    <button class="w-full bg-primary-600 text-white py-3 px-4 rounded-lg hover:bg-primary-700 transition-colors">
                        写评价
                    </button>
                </div>
            </div>
        `;

        // 添加点赞功能
        this.attachLikeHandlers(container);
    }

    // 渲染单个评论
    renderSingleComment(comment) {
        return `
            <div class="bg-white rounded-lg border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow">
                <div class="flex items-start space-x-4">
                    <img src="${comment.avatar}" alt="${comment.username}" class="w-12 h-12 rounded-full">
                    <div class="flex-1">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center space-x-3">
                                <h4 class="font-semibold text-gray-800">${comment.username}</h4>
                                <div class="flex items-center">
                                    ${this.renderStars(comment.rating)}
                                </div>
                                ${comment.helpful ? '<span class="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">有帮助</span>' : ''}
                            </div>
                            <span class="text-sm text-gray-500">${this.formatDate(comment.date)}</span>
                        </div>
                        <p class="mt-3 text-gray-700 leading-relaxed">${comment.content}</p>
                        <div class="mt-4 flex items-center space-x-4">
                            <button class="like-btn flex items-center space-x-1 text-gray-500 hover:text-blue-600 transition-colors" data-comment-id="${comment.id}">
                                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L9 7v13m-3-4l-2-2m0 0l-2-2m2 2v6"></path>
                                </svg>
                                <span class="like-count">${comment.likes}</span>
                            </button>
                            <button class="text-gray-500 hover:text-blue-600 transition-colors text-sm">回复</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    // 渲染星级评分
    renderStars(rating) {
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

        let starsHtml = '';
        
        // 实心星星
        for (let i = 0; i < fullStars; i++) {
            starsHtml += '<svg class="w-4 h-4 text-yellow-400 fill-current" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
        }
        
        // 半星
        if (hasHalfStar) {
            starsHtml += '<svg class="w-4 h-4 text-yellow-400" viewBox="0 0 20 20"><defs><linearGradient id="half"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><path fill="url(#half)" d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
        }
        
        // 空心星星
        for (let i = 0; i < emptyStars; i++) {
            starsHtml += '<svg class="w-4 h-4 text-gray-300 fill-current" viewBox="0 0 20 20"><path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/></svg>';
        }

        return `<div class="flex items-center">${starsHtml}</div>`;
    }

    // 计算平均评分
    getAverageRating(comments) {
        if (comments.length === 0) return 0;
        const total = comments.reduce((sum, comment) => sum + comment.rating, 0);
        return total / comments.length;
    }

    // 格式化日期
    formatDate(dateString) {
        const date = new Date(dateString);
        const now = new Date();
        const diffTime = Math.abs(now - date);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 1) return '昨天';
        if (diffDays < 7) return `${diffDays}天前`;
        if (diffDays < 30) return `${Math.floor(diffDays / 7)}周前`;
        if (diffDays < 365) return `${Math.floor(diffDays / 30)}个月前`;
        return `${Math.floor(diffDays / 365)}年前`;
    }

    // 添加点赞功能
    attachLikeHandlers(container) {
        const likeButtons = container.querySelectorAll('.like-btn');
        likeButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const commentId = parseInt(button.dataset.commentId);
                const likeCountSpan = button.querySelector('.like-count');
                const currentCount = parseInt(likeCountSpan.textContent);
                
                // 模拟点赞效果
                if (button.classList.contains('liked')) {
                    button.classList.remove('liked', 'text-blue-600');
                    button.classList.add('text-gray-500');
                    likeCountSpan.textContent = currentCount - 1;
                } else {
                    button.classList.add('liked', 'text-blue-600');
                    button.classList.remove('text-gray-500');
                    likeCountSpan.textContent = currentCount + 1;
                }
            });
        });
    }

    // 添加新评论（模拟功能）
    addComment(routeId, commentData) {
        if (!this.comments[routeId]) {
            this.comments[routeId] = [];
        }
        
        const newComment = {
            id: Date.now(),
            username: commentData.username || '匿名用户',
            avatar: commentData.avatar || 'https://api.dicebear.com/7.x/avataaars/svg?seed=anonymous',
            rating: commentData.rating || 5,
            date: new Date().toISOString().split('T')[0],
            content: commentData.content,
            likes: 0,
            helpful: false
        };
        
        this.comments[routeId].unshift(newComment);
        return newComment;
    }
}

// 导出评论系统实例
const commentSystem = new CommentSystem();

// 如果在浏览器环境中，将其添加到全局对象
if (typeof window !== 'undefined') {
    window.CommentSystem = CommentSystem;
    window.commentSystem = commentSystem;
}

export { CommentSystem, commentSystem };